import TableServiceOwnersCandidatesContainer from './TableServiceOwnerCandidates.container';
export default TableServiceOwnersCandidatesContainer;
